<section class="container">
    <div autofocus class="search-contents">
        <form [formGroup]="identificatorWEBForm" (ngSubmit)="resetAndLoadCertificates()">
            <div class="row-content">
                <mat-form-field class="col-4 line">
                    <mat-label>{{ 'businessTexts.fromValidityDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="fromDate" formControlName="fromDate" [max]="identificatorWEBForm.get('toDate')?.value || null">
                    <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
                    <button *ngIf="identificatorWEBForm.get('fromDate')?.value" matSuffix mat-icon-button
                        (click)="clearField('fromDate')">
                        <cqes-icon icon="close"></cqes-icon>
                    </button>
                    <mat-datepicker #fromDate></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-4 line">
                    <mat-label>{{ 'businessTexts.untilExpirationDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="toDate" formControlName="toDate" [min]="identificatorWEBForm.get('fromDate')?.value || null">
                    <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
                    <button *ngIf="identificatorWEBForm.get('toDate')?.value" matSuffix mat-icon-button
                        (click)="clearField('toDate')">
                        <cqes-icon icon="close"></cqes-icon>
                    </button>
                    <mat-datepicker #toDate></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-4">
                    <mat-select placeholder="{{'businessTexts.expired' | translate}}" formControlName="expired">
                        <mat-option *ngFor="let option of expiredsList" [value]="option">{{ option.label | translate}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row-content">
                <mat-form-field>
                    <mat-label>{{'businessTexts.name' | translate}}</mat-label>
                    <input matInput formControlName="name"
                        type="text">
                    <button *ngIf="identificatorWEBForm.get('name')?.value" matSuffix mat-icon-button
                        (click)="clearField('name')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <mat-form-field  class="custom-color">
                    <mat-label>{{'businessTexts.email' | translate}}</mat-label>
                    <input matInput formControlName="email"
                        type="email">
                    <button *ngIf="identificatorWEBForm.get('email')?.value" matSuffix mat-icon-button
                        (click)="clearField('email')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="identificatorWEBForm.get('email')?.hasError('email')">
                        {{ 'businessTexts.invalidEmail' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{'businessTexts.phone' | translate}}</mat-label>
                    <input matInput formControlName="phone"
                        type="tel">
                    <button *ngIf="identificatorWEBForm.get('phone')?.value" matSuffix mat-icon-button
                        (click)="clearField('phone')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="identificatorWEBForm.get('phone')?.hasError('pattern')">
                        {{ 'businessTexts.invalidPhone' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
            <div>
                <!-- <mat-error *ngIf="shouldShowIdentificatorError()">
                    {{ 'businessTexts.identificatorRequired' | translate }}
                </mat-error> -->
            </div>
            <div class="row-content-right">
                <button mat-raised-button type="button" (click)="clearFilters()">{{'businessTexts.clear' | translate}}</button>
                <button mat-raised-button type="submit" [disabled]="identificatorWEBForm.invalid">{{'businessTexts.search' | translate}}</button>
            </div>

        </form>
    </div>
    <div class="spinner-container" *ngIf="loading">
        <mat-spinner class="content-box"></mat-spinner>
    </div>
    <div class="message" *ngIf="!hasData() && !isLoading">
        {{'historyTexts.noDocumentsFound' | translate}}
    </div>

    <div class="data-container" [hidden]="!hasData() || isLoading">
        <div>
            <div class="col-md-12">
                <div class="message" *ngIf="!hasData()">
                    {{'businessTexts.identificationTable.noidentificationTable' | translate}}
                </div>
                <div class="data-container">
                    <div class="mat-elevation-z8 table-content">
                        <mat-table [dataSource]="idintificatorDataSource" matSort #sort="matSort" (matSortChange)="onSortChange($event)"
                            multiTemplateDataRows>
                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef="let status">
                                    <div class="status-head"> {{'businessTexts.identificationTable.status' | translate}}
                                    </div>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell">
                                        <div matTooltip="{{isItDanger(row).tooltip}}">
                                            <cqes-icon icon="{{isItDanger(row).icon}}" class="text-{{isItDanger(row).iconType}} row-status-identification {{isItDanger(row).isFilled ? 'cqes-icon-filled' : 'cqes-icon-outlined'}}"></cqes-icon>
                                        </div>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="registrationTime">
                                <mat-header-cell mat-sort-header *matHeaderCellDef="let registrationTime"
                                    class="registration-time-column">
                                    {{'businessTexts.identificationTable.registrationTime' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row" class="registration-time-column">
                                    <div class="cell">
                                        {{row.createdAt | date: 'dd.MM.yyyy HH:mm'}}
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell mat-sort-header *matHeaderCellDef="let name">
                                    {{'businessTexts.identificationTable.name' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell">
                                        <span>{{ getName(row.name) }}</span>
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <mat-header-cell #email id="email" *matHeaderCellDef="let email">
                                    {{'businessTexts.email' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">
                                    <div class="cell">
                                        {{row.email}}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="phone">
                                <mat-header-cell #phone id="phone" *matHeaderCellDef="let phone">
                                    {{'businessTexts.phone' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let row">{{row?.phoneNumber}}

                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell class="header-align-right" *matHeaderCellDef>
                                    {{ 'businessTexts.identificationTable.actions' | translate }}
                                </mat-header-cell>

                                <mat-cell *matCellDef="let row">
                                     <ng-container
                                       *ngIf="isItDanger(row).busnessHistoryHamburger?.length > 0">
                                        <span [matMenuTriggerFor]="docs" class="action">
                                            <button mat-icon-button color="primary">
                                                <cqes-icon icon="menu"></cqes-icon>
                                            </button>
                                        </span>

                                        <mat-menu #docs="matMenu">
                                            <div>
                                                <button mat-menu-item
                                                    *ngIf="isItDanger(row).busnessHistoryHamburger?.includes('details')"
                                                    (click)="viewDetailsDialog(row)">
                                                    <cqes-icon icon="settings"></cqes-icon>
                                                    {{'businessTexts.details' | translate}}
                                                </button>
                                            </div>
                                        </mat-menu>
                                    </ng-container>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;" class="expand-element-row">
                            </mat-row>
                        </mat-table>
                        <mat-paginator [length]="totalCountPages" [pageSize]="limit" [pageIndex]="paginatorPageIndex" [pageSizeOptions]="[5, 10, 20, 50]"
                            showFirstLastButtons (page)="onPaginateChange($event)">
                        </mat-paginator>
                    </div>

                </div>
            </div>
        </div>

    </div>
</section>